import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";

import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/bg.jpg';
import banner8 from '../assets/banner8.jpg';
import banner7 from '../assets/banner7.jpg';
import OneFocus from "./OneFocus";


import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";

export default function HomeBanner3(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					padding: "0",
					backgroundImage: `url(${banner5})`,
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
				}}
			>
				
				<div className="container">
					<div className="row" >

						<div className="col-md-12 mb-3">
							
							<div
							>
								<h6
									className="main-section-title"
								>
									Our Focus Areas

								</h6>

								<p
									style={{
										fontSize: "18px",
									}}
								>
									Fimacy Company Limited, Telecoms & Network Co. Ltd is focus on customer's retention and customers' long term satisfaction and timely delivery of services as key measures of the quality of our professionals and technical services.
									The Main objectives through our core values are:
								</p>

								
							</div>

						</div>

						<div className="col-md-12">
							
							<div className="row">
								<div className="col-md-12">
									<OneFocus
										order = "01"
										text = "Long term impact on society"
									/>

									<OneFocus
										order = "02"
										text = "To lead the industry in creating value for our customers and sales"
									/>

									<OneFocus
										order = "03"
										text = "To refocus on the value we offer our Customers"
									/>

									<OneFocus
										order = "04"
										text = "To increase potential Excellence"
									/>
								</div>
							</div>

						</div>

						
					</div>

				
				</div>
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
